import { SearchType, SearchStatus } from "@/shared/constants/enums";

export interface AdminUsersFilterOption {
  id: number;
  label: string;
  value: SearchType | SearchStatus;
  isActive: boolean;
}

export const AdminUsersFilterOptions = (
  type: SearchType
): AdminUsersFilterOption[] => {
  return [
    {
      id: 0,
      label: "Все",
      value: SearchType.all,
    },
    {
      id: 1,
      label: "ID",
      value: SearchType.id,
    },
    {
      id: 2,
      label: "Почта",
      value: SearchType.email,
    },
    {
      id: 3,
      label: "ФИО",
      value: SearchType.fio,
    },
  ].map((item) => ({ ...item, isActive: item.value === type }));
};

export const AdminUsersStatusOptions = (
  type: SearchStatus
): AdminUsersFilterOption[] => {
  return [
    {
      id: 0,
      label: "Все",
      value: SearchStatus.all,
    },
    {
      id: 1,
      label: "NONE",
      value: SearchStatus.none,
    },
    {
      id: 2,
      label: "Completed",
      value: SearchStatus.completed,
    },
    {
      id: 3,
      label: "Waiting",
      value: SearchStatus.waiting,
    },
    {
      id: 4,
      label: "Reject",
      value: SearchStatus.reject,
    },
  ].map((item) => ({ ...item, isActive: item.value === type }));
};
